import React from 'react'
import { createFilter } from 'react-search-input/lib/util'
import ComponentLoader from '../../../../../../../../Components/Loading/ComponentLoader'
import { BatchesEl } from './Elements'
import DashboardBatchesStore from '../../Stores/DashboardBatchesStore'
import BatchTab from './Components/BatchTab'
import FilterBox from './Components/FilterBox'
import SearchBox from './Components/SearchBox'
import BatchTimingsStore from '../../Stores/BatchTimingsStore'

function Batches({ userType }) {
  const {
    loading,
    loadFailed,
    batches = [],
    query,
    filter,
  } = DashboardBatchesStore.useContainer()

  const { batchId } = BatchTimingsStore.useContainer()

  const filteredBatches = batches
    .filter(createFilter(query, ['name']))
    .filter(({ classCount, completedClasses }) =>
      filter ? classCount > completedClasses : classCount <= completedClasses,
    )

  return (
    <ComponentLoader loading={loading} loadFailed={loadFailed}>
      <BatchesEl>
        <SearchBox />
        <div className='batches-list'>
          <FilterBox />
          {!filteredBatches.length && (
            <p>No {filter ? 'Active' : 'Completed'} Batches</p>
          )}
          {filteredBatches.map((batch) => (
            <BatchTab
              data={batch}
              isActive={batch.id === batchId}
              key={`batchTab-${batch.id}`}
              userType={userType}
            />
          ))}
        </div>
      </BatchesEl>
    </ComponentLoader>
  )
}

export default Batches
